module.exports = __webpack_public_path__ + "static/media/handling-relationships.8a87d272.svg";